import { render } from "./App.vue?vue&type=template&id=0204fb40"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0204fb40&lang=scss"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__